<template lang="pug">
  video#particles(playsinline preload muted ref="video" @ended="onVideoEnd")
    //- loop autoplay
    source(type="video/mp4" src="/videos/wave.mp4")
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Particles',
  props: {
  },
  watch: {
    $route(to, from) {
    },
    showParticlesWave() {
      const { showParticlesWave } = this;
      const { video } = this.$refs;
      if (showParticlesWave) video.play();
    },
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['showParticlesWave']),
  },
  methods: {
    ...mapActions(['toggleParticlesWave']),
    onVideoEnd() {
      const { toggleParticlesWave } = this;
      toggleParticlesWave(false);
    }
  },
  mounted() {
  },
  destroyed() {
  },
  components: {
  }
}
</script>

<style lang="scss">

#particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: screen;
  z-index: 1;
}

</style>
